
<section class="wrap">
  <div class="header">
    <div class="title">
      <fa-icon [icon]="getFaIcon('faChevronLeft')" [routerLink]="['/admin']" routerLinkActive="router-link-active"  appChangeColorTheme attribute="color"></fa-icon>
      <h2>{{title}}</h2>
    </div>

    <div class="add_search_payment">
             
      <div class="search_bar">
        <form [formGroup]="searchForm">
          <input type="text" placeholder="Chercher un paiement..." (input)="applyFilter($event.target.value)"
            formControlName="keyword">
        </form>

        <fa-icon [icon]="!valueInput? getFaIcon('faSearch'): getFaIcon('faTimes')" (click)="valueInput ? resetSearch(): null" ></fa-icon>

      </div>
    </div>
  </div>

  <div class="content">

    <div class="tabs">
      <div class="tabs" >
        <div [ngClass]="{tab_active: tab ==='all', tab: tab !== 'all'}" (click)="changeTab('all')">
         Tous les paiements
        </div>
       
        <div [ngClass]="{tab_active: tab ==='online', tab: tab !== 'online'}"
          (click)="changeTab('online')">
          Paiements en ligne
        </div>

        <div [ngClass]="{tab_active: tab ==='counter', tab: tab !== 'counter'}"
          (click)="changeTab('counter')">
          Paiements au guichet
        </div>
      </div>
    </div>

    <app-payments-table [data]="data" [keyword]="valueInput"></app-payments-table>
  </div>
</section>